import i18n from '@/utils/i18n';
import React from 'react';
import { AlertCardSkeleton } from './alert-card-skeleton';
import { AlertFeed } from './alert-feed';
import { Analytics } from '@/utils/analytics';
import { AnalyticsHubFeedScreens } from './types';
import { createStyles } from '@/contexts/theme-context';
import { HubCardData } from '@/hooks/insights-hub/types';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useHubCardNavigation } from '@/hooks/insights-hub/use-hub-card-navigation';
import { useInsightsHubAlerts } from '@/hooks/insights-hub/use-insights-hub-data';
import { useLayoutContext } from '@/contexts/layout-context';

export const HubFeed: React.FC = () => {
  const [styles] = useStyles();
  const { isSmallLayout } = useLayoutContext();

  const { data, error, loading } = useInsightsHubAlerts();
  const { navigateToRelevantScreen, navigateToViewAccount } =
    useHubCardNavigation();

  const onPress = (cardData: HubCardData) => {
    navigateToViewAccount(cardData);
    Analytics.track('insights_hub.alert.press', {
      alertType: cardData.card_type,
      restaurantUUID: cardData.restaurant_uuid,
      screen: AnalyticsHubFeedScreens.HubFeed,
    });
  };

  const onPressSupportInfo = (cardData: HubCardData) => {
    navigateToRelevantScreen(cardData);
    Analytics.track('insights_hub.alert.support_info.press', {
      alertType: cardData.card_type,
      restaurantUUID: cardData.restaurant_uuid,
      screen: AnalyticsHubFeedScreens.HubFeed,
    });
  };

  if (loading) {
    return (
      <View
        style={isSmallLayout ? styles.containerMobile : styles.containerDesktop}
      >
        {Array.from({ length: isSmallLayout ? 3 : 5 }).map((_, index) => (
          <AlertCardSkeleton key={index} />
        ))}
      </View>
    );
  }

  if (!data || error) {
    return null;
  }

  return (
    <View
      style={[
        !isSmallLayout
          ? [styles.containerDesktop, styles.mainColumnDesktop]
          : null,
      ]}
    >
      {!isSmallLayout ? (
        <Text style={[TYPOGRAPHY.h3, styles.header]}>
          {i18n.t('insights_hub')}
        </Text>
      ) : null}
      <AlertFeed
        data={data}
        onPress={onPress}
        onPressSupportInfo={onPressSupportInfo}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  containerDesktop: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 8,
  },
  containerMobile: {
    gap: 8,
  },
  header: {
    color: theme.colors.primary,
    fontSize: 21,
    lineHeight: 33.8,
    paddingHorizontal: 16,
  },
  mainColumnDesktop: {
    paddingHorizontal: 8,
    paddingTop: 16,
  },
}));
